import axios from "axios";
import { getLoggedUser } from "explorer/reducers/users";
import {
  fetchUserDeviceCheck,
  putChangeLanguage,
} from "shared/service/StrmService";
import { getBrowserId } from "shared/helpers/browser-id";
import { getGeneros, getGenerosSpotify } from "explorer/reducers/generos";
import { getCountries } from "explorer/reducers/countries";
import { cadastroRealizado, loginReduced } from "explorer/reducers/auth";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { LANG, TOKEN } from "shared/constants/LocalStorageConsts";
import Cookies from "js-cookie";
import { useTranslation } from "react-i18next";
import { getMonitoredData } from "explorer/reducers/monitored-data";

const AlternativeAutentication: React.FC<any> = (props) => {
  const { location } = props;
  const history = useHistory();
  const dispatch = useDispatch();
  const { i18n } = useTranslation();
  const { loggedUser } = useSelector((state: any) => state.users);

  useEffect(() => {
    const urlSearch = new URLSearchParams(location.search);
    const getAuthToken = async (code: string) => {
      const response: any = await axios.post(
        `${process.env.REACT_APP_HOST_ENDPOINT}auth/oauth2/token`,
        {
          code,
          redirectUri: encodeURIComponent(window.location.origin),
        }
      );

      const handleLanguage = async () => {
        const lang = Cookies.get(LANG);
        if (lang && i18n.hasResourceBundle(lang, "explorer")) {
          i18n.changeLanguage(lang);
          localStorage.setItem(LANG, lang);
          document.documentElement.lang = lang;
          await putChangeLanguage(i18n.language);
        }
      };

      localStorage.setItem(TOKEN, response.data);
      await handleLanguage();
      dispatch(getLoggedUser());
      dispatch(getGenerosSpotify());
      dispatch(getGeneros());
      dispatch(getCountries());
      dispatch(loginReduced());
      dispatch(getMonitoredData());

      const check = await fetchUserDeviceCheck(getBrowserId());
      if (check) {
        const returnURL = sessionStorage.getItem("returnURL");
        sessionStorage.removeItem("returnURL");
        if (returnURL) return history.push(returnURL);
        else return history.push("/");
      } else return history.push("/verificacao-dispositivo");
    };
    const code = urlSearch.get("code") || "";
    if (code) getAuthToken(code);
    // antes de colocar as dependencias tem que chegar como passar o método
  }, [dispatch, history, location, i18n]);

  useEffect(() => {
    const urlSearch = new URLSearchParams(location.search);
    const code = urlSearch.get("code") || "";
    if (
      code &&
      loggedUser.firstLoginInvestorsAt === loggedUser.lastLoginInvestorsAt
    )
      dispatch(cadastroRealizado());
  }, [loggedUser, dispatch, location]);

  return null;
};

export default AlternativeAutentication;
